import ServerError from 'errors/ServerError';
import { useGetCustomService } from './useGetCustomService';

export const useHistorialPerformanceData = ({ isEnabled = false }) => {
    const result = useGetCustomService({
        service: 'customAdvisoryServices',
        api: 'getPerformanceHistory',
        payload: null,
        enabled: isEnabled,
        gcTime: 5 * 60 * 1000,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    return {
        data: result?.data?.data?.historicalPerformances || null,
        statusCode: result?.data?.status,
        error: result.error ? new ServerError(result.error) : result.error,
    };
};
